module.exports = __webpack_public_path__ + "media/images/products/cards/fundos_imobiliários-247d6a49890470497098105a53469b6d.png";